/**
 * This is where the references to the theme variables such as {@link TYPOGRAPHY} are stored.
 * The remapping of the contents to the specific theme happens in {@link loadThemeVariables} which is invoked before any of the react components are initialized.
 * eg: When you access {@link TYPOGRAPHY} you are accessing SHARED_VARIABLES_REFERENCE_OBJECT.TYPOGRAPHY
 * To update variables for a theme, import your theme specific variables onto {@link themeVariables} and make sure that process.env.REACT_APP_THEME is set to that {@link BASE_THEME_IDS} key.
 */
export var SHARED_VARIABLES_REFERENCE_OBJECT = {
  TYPOGRAPHY: {},
  BREAKPOINTS: {},
  BREAKPOINTS_EM: {},
  BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY: {},
  DEFAULT_BREAKPOINTS_ASC: [],
  MARGINS: {} // TODO deprecate MARGINS, use SPACINGS

};